import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ApiService} from '../api.service';
import {Location} from '@angular/common'; 
import { GlobalServices } from '../global.services';
declare var XLSX: any;
@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.scss']
})
export class SiteMapComponent implements OnInit {

  public siteMapResponse: Array<any> = [];
  constructor(
    private httpService: ApiService,
    private router: Router,
    public location: Location,
    private globalService: GlobalServices) { }

  ngOnInit() {
    if(this.globalService?.isBrowser){
      this.globalService?.hideHeader.next(false);
      this.globalService?.hideFooter.next(false);
      this.loadSiteMapData();
    }
  }

  loadSiteMapData() {
    // let Url: string = "home/category-subcategory";
    // this.httpService.getData(Url).subscribe(response => {
    //   this.siteMapResponse = response && response['data'] ? response['data'] : [];
    // })

    this.httpService.getDataFromExcel('https://docs.google.com/spreadsheets/d/1HLFWSXvSOCn2yrzvhwOZBHxjoz6FJDLlRQvu322Y9Is/edit?usp=sharing').subscribe(response => {
      var selectedFile = response;
      if (selectedFile) {
        var fileReader = new FileReader();
        var self = this;
        fileReader.onload = function (event) {
          var data = event.target['result'];
          var workbook = XLSX.read(data, {
            type: 'binary'
          });
          workbook.SheetNames.forEach(sheet => {
            let rowObject = XLSX.utils.sheet_to_row_object_array(
              workbook.Sheets[sheet]
            );
            let jsonObject = JSON.stringify(rowObject);
            self.filterSiteMapData(jsonObject);
          });
        };
        fileReader.readAsBinaryString(selectedFile);
      }
    })
  }
  siteMapData: Array<any> = [];
  public navigateToCategory(cat): void {
    this.router.navigate(['/categories'], { queryParams: { "programCategory": cat.slug } });

  }
  public filterSiteMapData(jsonObject): void {
    if (jsonObject) {
      let newArray: Array<any> = typeof jsonObject == "string" ? this.replaceArray(JSON.parse(jsonObject)) : this.replaceArray(jsonObject);
      this.siteMapData = newArray;
    }
  }
  public navigateToSubCategory(subCat): void {
    this.router.navigate(['/categories'], { queryParams: { "programSubCategory": subCat.slug } });

  }
  // public navigate(route): void {
  //   console.log(route);
  //   location.href=route;
  //   this.location.go(route);
  //   // this.router.navigate([route]);
  // }

  public replaceArray(arr): Array<any> {
    let newArr = [];
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index];
      if (index > 0 && element && element['C']) {
        // code to make live url to current url
        // let changeUrlArray:any='';
        // if((element['C']).includes('https://www.MyTripwell.com/')){
        // changeUrlArray = element['C'].split('https://www.MyTripwell.com/');
        // }else{
        // changeUrlArray = element['C'].split('https://www.mylifewell.com/');
        // }
        // changeUrlArray[0] = "/";
        // element['C'] = changeUrlArray[0] + "" + changeUrlArray[1];


        if (element['C'].indexOf('hotels-resorts/') > -1) {

        } else {
          newArr.push(element);
        }
      }

    }
    return newArr;
  }
}
